/* [Modified by Codex at 2026-10-12] 登录与表单反馈即时可用，其他弹窗按实际组件加载 */
var BlsPopupMessage = (function () {
    return {
        init: function () {
            this.checkFormInfo(), this.checkShowMsgStockNotify();
        },
        checkFormInfo: function () {
            const urlInfo = window.location.href;
            const formInfo = document.querySelector(".form-infor");
            const formError = document.querySelector(".form-infor-body.noti-error");
            const formSuccess = document.querySelector(
                ".form-infor-body.noti-success"
            );
            const closeButton = document.querySelector(
                ".form-infor .close-form-info"
            );
            if (closeButton) {
                closeButton.addEventListener("click", (e) => {
                    const closestForm = e.currentTarget.closest(".form-infor");
                    e.preventDefault();
                    if (closestForm.classList.contains("show-noti-form")) {
                        closestForm.classList.remove("show-noti-form");
                    }
                });
            }
            const checkUrlAndAct = (urlCheck, action) => {
                if (urlInfo.indexOf(urlCheck) > -1) {
                    action();
                }
            };
            const showNotificationSuccess = () => {
                formInfo.classList.add("show-noti-form");
                formError.style.display = "none";
                setCookie("bls-newsletter-popup", "99999", "bls");
                removeElementById("newsletterp_0");
                updateHistoryState();
            };
            const showNotificationError = () => {
                formInfo.classList.add("show-noti-form");
                formSuccess.style.display = "none";
                updateHistoryState();
            };
            checkUrlAndAct(
                "contact[tags]=newsletter&form_type=customer",
                showNotificationError
            );
            checkUrlAndAct("customer_posted=true", showNotificationSuccess);
            checkUrlAndAct(
                "contact_posted=true#askquestion",
                showNotificationSuccess
            );
            function removeElementById(id) {
                const element = document.getElementById(id);
                if (element) {
                    element.remove();
                }
            }
            function updateHistoryState() {
                const baseURL = location.href.split("?")[0];
                window.history.pushState(
                    { object: "newTitle" },
                    document.title,
                    baseURL
                );
            }
        },
        checkShowMsgStockNotify: function () {
            const urlInfo = window.location.href;
            const formInfo = document.querySelector(".stock-notify");
            const fi = document.querySelector(
                ".stock-notify,.close-form-stock-notify"
            );
            if (fi) {
                fi.addEventListener("click", (e) => {
                    const target = e.currentTarget;
                    const closet = target.closest(".stock-notify");
                    e.preventDefault();
                    if (closet.classList.contains("show-noti-form")) {
                        closet.classList.remove("show-noti-form");
                    }
                });
            }
            if (urlInfo.indexOf("contact_posted=true#FormStockNotify") > -1) {
                formInfo.classList.add("show-noti-form");
                const newURL = location.href.split("?")[0];
                window.history.pushState("object", document.title, newURL);
            }
        },
    };
})();
BlsPopupMessage.init();

class LoginPopup extends Popup {
    constructor() {
        super();
        // 2026-05-13：自动弹窗相关状态
        this.autoShowTimer = null;
        this.scrollHandler = null;
        this.hasShown = false;
        this.init();
    }

    init() {
        const action = this.querySelector(".action-login");
        const _this = this;
        if (action !== null) {
            action.addEventListener("click", (e) => {
                e.preventDefault();
                // 2026-05-14: 修改登录方式为 Shopify 客户账户登录
                _this.cancelAutoShow();
                // 2026-05-14: 注释掉原弹窗打开逻辑，改为跳转到 Shopify 客户登录页面
                // _this.fetchDataLogin();
                // document.body.classList.add("login-popup-show");

                // 2026-05-14: 点击登录图标跳转到 Shopify 客户登录 URL
                window.location.href = "https://account.vedress.com";
            });
        }
        // 2026-05-14: 自动弹窗功能由全局设置 login_popup_max_count 控制，默认设为 0 已禁用
        this.initAutoShow();
    }

    // 2026-05-13：10秒延时或50%滚动触发登录弹窗，受次数上限控制
    initAutoShow() {
        if (this.dataset.autoShow !== "true") return;

        var maxCount = parseInt(this.dataset.autoShowMax) || 0;
        if (maxCount <= 0) return;

        var shownCount = parseInt(sessionStorage.getItem("bls-login-popup-count")) || 0;
        if (shownCount >= maxCount) return;

        const _this = this;

        this.autoShowTimer = setTimeout(() => {
            _this.triggerAutoShow();
        }, 10000);

        this.scrollHandler = throttle(() => {
            const scrollPercent =
                ((window.scrollY + window.innerHeight) /
                    document.documentElement.scrollHeight) *
                100;
            if (scrollPercent >= 50) {
                _this.triggerAutoShow();
            }
        }, 200);
        window.addEventListener("scroll", this.scrollHandler, { passive: true });
    }

    // 2026-05-13：任一条件触发后清理定时器和滚动监听
    triggerAutoShow() {
        if (this.hasShown) return;
        this.cancelAutoShow();
        this.fetchDataLogin();
    }

    // 2026-05-13：取消自动弹窗，递增 sessionStorage 计数器
    cancelAutoShow() {
        if (this.hasShown) return;
        this.hasShown = true;
        var shownCount = parseInt(sessionStorage.getItem("bls-login-popup-count")) || 0;
        sessionStorage.setItem("bls-login-popup-count", shownCount + 1);
        if (this.autoShowTimer) {
            clearTimeout(this.autoShowTimer);
            this.autoShowTimer = null;
        }
        if (this.scrollHandler) {
            window.removeEventListener("scroll", this.scrollHandler);
            this.scrollHandler = null;
        }
    }

    clickTab() {
        const hidden = document.querySelectorAll("[data-login-hidden]");
        const show = document.querySelectorAll("[data-login-show]");
        const iTitle = document.querySelector(
            "#loginp_0 .dlg-heading .popup-title"
        );
        show.forEach((e) => {
            var s = e?.dataset.loginShow;
            e.addEventListener("click", function (el) {
                el.preventDefault();
                hidden.forEach((eh) => {
                    var h = eh?.dataset.loginHidden;
                    if (eh.getAttribute("aria-hidden") === "true" && s === h) {
                        eh.setAttribute("aria-hidden", "false");
                        if (iTitle) {
                            iTitle.innerText = s;
                        }
                    } else {
                        eh.setAttribute("aria-hidden", "true");
                    }
                });
            });
        });
    }

    fetchDataLogin() {
        const url = `${window.location.pathname}?section_id=login-popup`;
        const _this = this;
        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = newParser.parseFromString(responseText, "text/html");
                const l = html.querySelector("#login-popup");
                if (l) {
                    var titleLoginDefault = l.querySelector("[data-title-default]");
                    var dataTitleLogin = titleLoginDefault.dataset.titleDefault;
                    this.initPopupJs(
                        l.innerHTML,
                        dataTitleLogin,
                        "loginp",
                        true,
                        false
                    );
                }
                _this.clickTab();
            })
            .catch((e) => {
                throw e;
            });
    }
}
customElements.define("login-popup", LoginPopup);

/* [End] */

/* [Modified by Codex at 2026-10-12] 按新增弹窗范围加载组件并保留首次图片点击 */
(() => {
    const source = document.currentScript;
    const components = new Map([
        ['newsletter-popup', source?.dataset.newsletterSrc],
        ['promotion-popup', source?.dataset.promotionSrc],
        ['age-verifier', source?.dataset.ageVerifierSrc],
        ['instagram-shop', source?.dataset.instagramShopSrc],
    ]);
    const requests = new Map();

    function loadComponent(tag) {
        if (customElements.get(tag)) return Promise.resolve();
        const url = components.get(tag);
        if (!url) return Promise.reject(new Error('Missing popup component resource.'));
        if (requests.has(url)) return requests.get(url);
        const script = document.createElement('script');
        script.src = url;
        const request = new Promise((resolve, reject) => {
            const fail = () => {
                requests.delete(url);
                script.remove();
                reject(new Error('Unable to load popup component.'));
            };
            script.addEventListener('load', () => {
                if (customElements.get(tag)) resolve();
                else fail();
            }, { once: true });
            script.addEventListener('error', fail, { once: true });
        });
        requests.set(url, request);
        document.head.appendChild(script);
        return request;
    }

    function scan(root) {
        if (!root?.querySelector) return;
        components.forEach((url, tag) => {
            if (!url || customElements.get(tag)) return;
            if (root.matches?.(tag) || root.querySelector(tag)) {
                loadComponent(tag).catch((error) => console.warn(error.message));
            }
        });
    }

    document.addEventListener('click', (event) => {
        const image = event.target.closest?.('instagram-shop img');
        if (!image || customElements.get('instagram-shop')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        loadComponent('instagram-shop').then(() => {
            if (image.isConnected) image.click();
        }).catch((error) => console.warn(error.message));
    }, true);

    scan(document);
    const observer = new MutationObserver((records) => {
        records.forEach((record) => record.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) scan(node);
        }));
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
/* [End] */
